import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskEndSoonReceiverUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskEndSoonReceiverUI;
